<template>
    <div class="flex flex-col items-center gap-1">
        <!-- Thumbnail -->
        <div
            class="relative rounded overflow-hidden cursor-pointer border-2 flex items-center justify-center select-none flex-shrink-0"
            :class="isDragging ? 'border-blue-400 bg-blue-900' : 'border-gray-600 bg-gray-700 hover:border-blue-400'"
            :style="{ width: size + 'px', height: size + 'px' }"
            @click="$refs.fileInput.click()"
            @dragover.prevent="isDragging = true"
            @dragleave.prevent="isDragging = false"
            @drop.prevent="onDrop"
            :title="modelValue ? 'Click to replace icon' : 'Click or drop image to set icon'"
        >
            <img v-if="modelValue" :src="modelValue" class="w-full h-full object-contain" />
            <span v-else class="text-gray-400" :style="{ fontSize: Math.round(size * 0.45) + 'px' }">{{ placeholder }}</span>

            <!-- Hover overlay -->
            <div class="absolute inset-0 bg-black bg-opacity-0 hover:bg-opacity-50 flex flex-col items-center justify-center gap-1 opacity-0 hover:opacity-100 transition-opacity">
                <span class="text-white text-xs font-semibold">{{ modelValue ? 'Upload' : 'Upload' }}</span>
                <button v-if="modelValue"
                    class="text-red-400 text-xs hover:text-red-300 font-semibold"
                    @click.stop="$emit('update:modelValue', null)"
                >Remove</button>
            </div>

            <input ref="fileInput" type="file" :accept="accept" class="hidden" @change="onFileChange" />
        </div>

        <!-- Draw button -->
        <button
            class="text-xs px-2 py-0.5 rounded bg-gray-700 hover:bg-gray-600 text-gray-300 w-full"
            @click="showEditor = true"
        >Draw</button>

        <!-- Drawing editor popup -->
        <IconEditorModal
            v-if="showEditor"
            :initial-icon="modelValue"
            @save="onEditorSave"
            @cancel="showEditor = false"
        />
    </div>
</template>

<script>
import IconEditorModal from './IconEditorModal.vue';

export default {
    name: 'IconEditor',
    components: { IconEditorModal },

    props: {
        modelValue: { type: String, default: null },
        size:        { type: Number, default: 64 },
        placeholder: { type: String, default: '🧩' },
        accept:      { type: String, default: 'image/png,image/svg+xml,image/jpeg' },
    },
    emits: ['update:modelValue'],

    data() {
        return {
            isDragging: false,
            showEditor: false,
        };
    },

    methods: {
        onFileChange(event) {
            const file = event.target.files[0];
            event.target.value = '';
            if (file) this.readFile(file);
        },
        onDrop(event) {
            this.isDragging = false;
            const file = event.dataTransfer.files[0];
            if (file && this.accept.split(',').some(t => file.type.match(t.trim()))) {
                this.readFile(file);
            }
        },
        readFile(file) {
            const reader = new FileReader();
            reader.onload = (e) => this.$emit('update:modelValue', e.target.result);
            reader.readAsDataURL(file);
        },
        onEditorSave(dataUrl) {
            this.$emit('update:modelValue', dataUrl);
            this.showEditor = false;
        },
    },
};
</script>
